import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download_production/6a751a928295d50014d45c0c_1788968020428_59fff058/celsoft/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/home/ubuntu/download_production/6a751a928295d50014d45c0c_1788968020428_59fff058/celsoft/src/contexts/NotificationContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a751a928295d50014d45c0c_1788968020428_59fff058/celsoft/src/styles/tailwind.css");
